import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ImportModal;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Alert } from '@instructure/ui-alerts';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { ProgressBar } from '@instructure/ui-progress';
import { Heading } from '@instructure/ui-heading';
import { Tabs } from '@instructure/ui-tabs';
import { ToggleDetails } from '@instructure/ui-toggle-details';
import { jsx } from '@instructure/emotion';
import { ImportantModal, ModalHeader, ModalBody, ModalFooter, FILE_UPLOAD_SELECT, FILE_UPLOAD_IMPORTING, FILE_UPLOAD_SUCCESS, FILE_UPLOAD_FAILURE, FILE_UPLOAD_ERROR, TextInput, XSMALL_SIDE_MARGIN, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import ImportFileSelector from './ImportFileSelector';
import t from '@instructure/quiz-i18n/format-message';
export var ImportModal = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ImportModal = /*#__PURE__*/function (_Component) {
  function ImportModal() {
    var _this2;
    _classCallCheck(this, ImportModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ImportModal, [].concat(args));
    _defineProperty(_this2, "state", {
      selectedTabIndex: 0
    });
    _defineProperty(_this2, "componentDidUpdate", function (prevProps, prevState) {
      if (!_this2.props.modalOpen) {
        return;
      }
      var _this2$props = _this2.props,
        disableConfirm = _this2$props.disableConfirm,
        uploadStatus = _this2$props.uploadStatus;
      var isUploadSuccess = uploadStatus === FILE_UPLOAD_SUCCESS && uploadStatus !== prevProps.uploadStatus;
      if (disableConfirm && isUploadSuccess) {
        _this2.continueAction();
      }
      if (uploadStatus !== prevProps.uploadStatus) {
        _this2.alertScreenreader();
      }
    });
    _defineProperty(_this2, "cancelAction", function () {
      _this2.props.clearFiles();
      _this2.props.clearAltText();
      if (_this2.props.closeOverride) {
        // this timeout is needed because if this modal closes first,
        // then the ItemFeedbackModal will also close in the same click
        // since it will think the click happened "onOverlayClick"
        setTimeout(_this2.props.closeOverride);
      } else {
        _this2.props.closeModal();
      }
      // Wait for the modal to close before setting the status to prevent flashing
      // the select screen when closing the modal due to the modal having a gradual
      // fade transition that will display the change in state
      setTimeout(function () {
        return _this2.props.setUploadStatus(FILE_UPLOAD_SELECT);
      }, 300);
    });
    _defineProperty(_this2, "errorAction", function () {
      return _this2.props.setUploadStatus(FILE_UPLOAD_ERROR);
    });
    _defineProperty(_this2, "continueAction", function () {
      var uploadStatus = _this2.props.uploadStatus;
      switch (uploadStatus) {
        case FILE_UPLOAD_SUCCESS:
        case FILE_UPLOAD_FAILURE:
          _this2.cancelAction();
          break;
        case FILE_UPLOAD_ERROR:
          _this2.props.clearFiles();
          _this2.props.clearAltText();
          _this2.props.setUploadStatus(FILE_UPLOAD_SELECT);
          break;
        default:
          _this2.props.fileUpload(_this2.props.files.get(0), _this2.errorAction, _this2.props.altText);
          _this2.props.setUploadStatus(FILE_UPLOAD_IMPORTING);
          _this2.props.onContinue();
          break;
      }
    });
    _defineProperty(_this2, "handleFile", function (file) {
      _this2.props.receiveFile(file);
      _this2.confirmButton.focus();
    });
    _defineProperty(_this2, "onAltTextChange", function (e) {
      _this2.props.setAltText(e.target.value);
    });
    _defineProperty(_this2, "handleTabChange", function (event, _ref) {
      var index = _ref.index;
      _this2.setState({
        selectedTabIndex: index
      });
    });
    return _this2;
  }
  _inherits(ImportModal, _Component);
  return _createClass(ImportModal, [{
    key: "componentDidUpdate",
    value:
    // TODO: This is a duplicate of the componentDidUpdate above which can lead to bugs.
    // It was discovered during the ESLint upgrade. This should be fixed ASAP.
    // eslint-disable-next-line no-dupe-class-members
    function componentDidUpdate() {
      if (this.props.uploadStatus === FILE_UPLOAD_SUCCESS && this.props.modalOpen) {
        this.cancelAction();
      }
    }
  }, {
    key: "setRef",
    value: function setRef(refName) {
      var _this3 = this;
      return function (node) {
        _this3[refName] = node;
      };
    }
  }, {
    key: "disableCancelButton",
    value: function disableCancelButton() {
      var uploadStatus = this.props.uploadStatus;
      return [FILE_UPLOAD_ERROR, FILE_UPLOAD_FAILURE, FILE_UPLOAD_SUCCESS].includes(uploadStatus);
    }
  }, {
    key: "cancelButton",
    value: function cancelButton() {
      return jsx(Button, {
        disabled: this.disableCancelButton(),
        onClick: this.cancelAction,
        margin: XSMALL_SIDE_MARGIN,
        ref: this.setRef('cancelImportButton'),
        "data-automation": "sdk-cancel-import-button"
      }, t('Cancel'));
    }
  }, {
    key: "disableContinueButton",
    value: function disableContinueButton() {
      var _this$props = this.props,
        uploadStatus = _this$props.uploadStatus,
        files = _this$props.files;
      return uploadStatus === FILE_UPLOAD_IMPORTING || files.size === 0;
    }
  }, {
    key: "continueButtonMessage",
    value: function continueButtonMessage() {
      var uploadStatus = this.props.uploadStatus;
      switch (uploadStatus) {
        case FILE_UPLOAD_FAILURE:
          return t('Okay');
        case FILE_UPLOAD_SUCCESS:
          return t('Done');
        case FILE_UPLOAD_ERROR:
          return t('Start Over');
        default:
          return t('Import');
      }
    }
  }, {
    key: "continueButton",
    value: function continueButton() {
      return jsx(Button, {
        onClick: this.continueAction,
        color: "primary",
        disabled: this.disableContinueButton(),
        margin: XSMALL_SIDE_MARGIN,
        ref: this.setRef('confirmButton'),
        "data-automation": "sdk-continue-import-button"
      }, this.continueButtonMessage());
    }
  }, {
    key: "renderErroredContent",
    value: function renderErroredContent() {
      return jsx(Alert, {
        variant: "error",
        ref: this.setRef('errorAlert')
      }, this.uploadStatusMessage());
    }
  }, {
    key: "renderSelectingContent",
    value: function renderSelectingContent(fileType) {
      return jsx("div", null, jsx("div", null, this.props.importMessage), jsx(ImportFileSelector, {
        files: this.props.files,
        ref: this.setRef('fileSelector'),
        receiveFile: this.handleFile,
        acceptAttribute: fileType,
        "data-automation": "sdk-import-file-selector"
      }), fileType === 'image/*' && jsx("div", {
        css: this.props.styles.altTextWrapper
      }, jsx(TextInput, {
        ref: this.setRef('altTextInput'),
        onChange: this.onAltTextChange,
        value: this.props.altText,
        renderLabel: jsx("div", null, t('alt text (optional)')),
        type: "text"
      })));
    }
  }, {
    key: "renderFailureContent",
    value: function renderFailureContent() {
      return jsx("div", null, jsx(Alert, {
        variant: "error",
        ref: this.setRef('failureAlert'),
        "data-automation": "sdk-import-error-alert"
      }, jsx("div", null, this.uploadStatusMessage(), jsx(ToggleDetails, {
        summary: jsx(Text, {
          size: "small"
        }, t('Error Details'))
      }, jsx(Text, {
        size: "small"
      }, this.props.failureMessage)))));
    }
  }, {
    key: "renderSuccessContent",
    value: function renderSuccessContent() {
      return jsx(Alert, {
        variant: "success",
        ref: this.setRef('successAlert'),
        "data-automation": "sdk-import-success-alert"
      }, this.uploadStatusMessage());
    }
  }, {
    key: "renderImportingContent",
    value: function renderImportingContent() {
      return jsx(ProgressBar, {
        screenReaderLabel: t('Import process completion'),
        valueNow: this.props.progressValue,
        ref: this.setRef('progressBar')
      });
    }
  }, {
    key: "uploadStatusMessage",
    value: function uploadStatusMessage() {
      if (this.props.uploadStatus === FILE_UPLOAD_FAILURE) {
        return t('Error: there was a problem importing your file.');
      } else if (this.props.uploadStatus === FILE_UPLOAD_ERROR) {
        return t('Error: there was a problem uploading your file.');
      } else if (this.props.uploadStatus === FILE_UPLOAD_SUCCESS) {
        var file = this.props.files.get(0);
        var fileName = file ? file.name : '';
        return t('Success: {fileName} has imported successfully!', {
          fileName: fileName
        });
      }
    }
  }, {
    key: "alertScreenreader",
    value: function alertScreenreader() {
      var msg = this.uploadStatusMessage();
      if (msg) {
        this.props.screenreaderNotification(msg);
      }
    }
  }, {
    key: "renderImportContent",
    value: function renderImportContent(fileType) {
      switch (this.props.uploadStatus) {
        case FILE_UPLOAD_FAILURE:
          return this.renderFailureContent();
        case FILE_UPLOAD_SUCCESS:
          return this.renderSuccessContent();
        case FILE_UPLOAD_ERROR:
          return this.renderErroredContent();
        case FILE_UPLOAD_IMPORTING:
          return this.renderImportingContent();
        default:
          return this.renderSelectingContent(fileType);
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this4 = this;
      if (typeof this.props.acceptFileType === 'string') {
        return this.renderImportContent(this.props.acceptFileType);
      }
      var selectedIndex = this.state.selectedTabIndex;
      return jsx(Tabs, {
        onRequestTabChange: this.handleTabChange,
        variant: "secondary"
      }, this.props.acceptFileType.map(function (_ref2, index) {
        var fileType = _ref2.fileType,
          title = _ref2.title;
        return jsx(Tabs.Panel, {
          key: title,
          renderTitle: title,
          disabled: _this4.props.files.size > 0 && index !== selectedIndex,
          isSelected: selectedIndex === index
        }, _this4.renderImportContent(fileType));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(ImportantModal, {
        open: this.props.modalOpen,
        size: "small",
        onClose: this.props.onClose,
        onDismiss: this.cancelAction,
        label: t('Import Content'),
        ref: this.setRef('modal'),
        "data-automation": "sdk-import-content-modal"
      }, jsx(ModalHeader, null, jsx(Heading, {
        level: "reset",
        as: "h2"
      }, t('Import Content')), jsx(CloseButton, {
        onClick: this.cancelAction,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), jsx(ModalBody, null, this.renderContent()), jsx(ModalFooter, null, this.cancelButton(), this.continueButton()));
    }
  }]);
}(Component), _defineProperty(_ImportModal, "displayName", 'ImportModal'), _defineProperty(_ImportModal, "componentId", "Quizzes".concat(_ImportModal.displayName)), _defineProperty(_ImportModal, "propTypes", {
  acceptFileType: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape({
    fileType: PropTypes.string,
    title: PropTypes.string
  }))]).isRequired,
  altText: PropTypes.string.isRequired,
  // passed in by connect
  clearAltText: PropTypes.func.isRequired,
  // passed in by connect
  clearFiles: PropTypes.func.isRequired,
  // passed in by connect
  closeModal: PropTypes.func.isRequired,
  // passed in by connect
  closeOverride: PropTypes.func,
  disableConfirm: PropTypes.bool,
  failureMessage: PropTypes.string.isRequired,
  files: ImmutablePropTypes.list.isRequired,
  // passed in by connect
  fileUpload: PropTypes.func.isRequired,
  importMessage: PropTypes.string.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  // passed in by connect
  onClose: PropTypes.func,
  onContinue: PropTypes.func.isRequired,
  progressValue: PropTypes.number.isRequired,
  receiveFile: PropTypes.func.isRequired,
  // passed in by connect
  screenreaderNotification: PropTypes.func.isRequired,
  // passed in by connect
  setAltText: PropTypes.func.isRequired,
  // passed in by connect
  setUploadStatus: PropTypes.func.isRequired,
  // passed in by connect
  uploadStatus: PropTypes.oneOf([FILE_UPLOAD_SELECT, FILE_UPLOAD_IMPORTING, FILE_UPLOAD_SUCCESS, FILE_UPLOAD_FAILURE, FILE_UPLOAD_ERROR]).isRequired,
  // passed in by connect,
  styles: PropTypes.object
}), _defineProperty(_ImportModal, "defaultProps", {
  closeOverride: null,
  disableConfirm: false,
  onClose: function onClose() {}
}), _ImportModal)) || _class);
export default ImportModal;